module.exports = __webpack_public_path__ + "img/IMG_0057_L_WoodMatted.390c4a62.jpg";